import { runAppBootChain } from 'src/main'

export default (ctx) => {
  return runAppBootChain(ctx)
}
